import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/close-recommend.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-11c15f94"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "close-recommend-img",
  src: _imports_0
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "close-recommend-txt" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "titie-top" }, "【智能推荐】功能还未开启，暂时无法推荐题目"),
  /*#__PURE__*/_createElementVNode("p", { class: "titie-bottom" }, "您可在【我的-设置】中开启")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({'close-recommend':_ctx.source == 'recommendList', 'close-recommend-question':_ctx.source == 'question'})
  }, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("p", {
      class: "close-recommend-btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goSetRecommendStatus()))
    }, "立即开启")
  ], 2))
}